// extracted by mini-css-extract-plugin
module.exports = {"pagination":"StickyPagination_pagination__9Qfhq"};